import r from"./_baseGet.js";var t=r;var e=function(r){return function(e){return t(e,r)}};export{e as default};
//# sourceMappingURL=_basePropertyDeep.js.map
